export { default } from 'features/account/routes/account-drawer-route';
